import { render, staticRenderFns } from "./VendorCompItemDetail.vue?vue&type=template&id=55a11f0e"
import script from "./VendorCompItemDetail.vue?vue&type=script&lang=js"
export * from "./VendorCompItemDetail.vue?vue&type=script&lang=js"
import style0 from "./VendorCompItemDetail.vue?vue&type=style&index=0&id=55a11f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports